function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M134.6 184.2H0v28.5h7v70.9h120.6v-70.9h7v-28.5zm-35.5 70.9H35.5v-42.4h63.6v42.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.6 219.5H85V234H49.6zM283.5 184.2H148.8v28.5h7v70.9h120.6v-70.9h7l.1-28.5zM248 255.1h-63.6v-42.4H248v42.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M198.5 219.5h35.4V234h-35.4zM209.1 63.8H74.4v28.5h7v70.9H202V92.3h7l.1-28.5zm-35.6 70.8h-63.6V92.3h63.6v42.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.1 99.1h35.4v14.5h-35.4z"
})));